import { Component, EventEmitter, Input, Output, Pipe, PipeTransform } from '@angular/core';
import { ProductData } from './product-search.service';

@Pipe({
  name: 'formatPartnerName',
  pure: true,
})
export class FormatPartnerNamePipe implements PipeTransform {
  transform(partnerName: string, partnerId: string): string {
    if (partnerName === partnerId) {
      return partnerId;
    }
    return `${partnerName} (${partnerId})`;
  }
}

@Component({
  selector: 'app-product-row',
  template: `
    <a
      mat-list-item
      tabindex="0"
      (click)="handleProductSelected(product)"
      (keyup.enter)="handleProductSelected(product)"
    >
      <glxy-avatar
        matListItemAvatar
        [name]="product.productName"
        [src]="product.productIcon"
        [width]="32"
      ></glxy-avatar>
      <h4 matListItemTitle>{{ product.productName }}</h4>
      <span matListItemLine>{{ product.partnerName | formatPartnerName : product.partnerId }}</span>
      <p matListItemLine class="app-id">{{ product.productId }}</p>
    </a>
  `,
  styleUrls: ['../common.scss', './product-row.component.scss'],
})
export class ProductRowComponent {
  @Input()
  product: ProductData;

  @Output()
  productSelected = new EventEmitter<ProductData>();

  handleProductSelected(product: ProductData) {
    this.productSelected.emit(product);
  }
}
